import React, {useEffect, useState} from 'react';

import {machine as m} from "../../constants/machine.constants";
import {ProgressBarWithPause} from "../../index";
import {useMainStateMachine, useMainState} from "../MainStateMachineProvider";
import {CounterManager} from "../CounterManager/CounterManager";

import css from "./ProgressBarManager.module.css"

const ProgressBarManager = () => {
    const {send} = useMainStateMachine();
    const state = useMainState();
    const [isCounterActive, setIsCounterActive] = useState(false)
    const isActive = state.matches(m.state.delaySound) ||
        state.matches(m.state.delayPlayingScenario)
        || isCounterActive;

    const currentStepDelay = state.context.stepDelay || 0;
    const currentScenarioDelay = state.context.currentItem?.props?.delay || 0;
    
    const counterSettings = {
        local: {name: "delay", value: currentScenarioDelay},
        global: {name: "stepDelay", value: currentStepDelay}
    }

    useEffect(() => {
        if (state.value !== m.state.paused) setIsCounterActive(() => false)
    }, [state.value])

    const toggleIsCounterActiveClick = () => {
        setIsCounterActive(prev => !prev)
        send({type: "TOGGLE_PAUSE_PLAY"});
    }

    const classList = [css.ProgressBarManager];
    classList.push(isActive ? css.open : css.closed)

    const changeCount = (type) => {
        const guard = true; // Always Local in player
        const payload = counterSettings.local;
        if (type === "inc") {
            send({type: m.events.INCREMENT, data: {payload, guard}})
        } else {
            send({type: m.events.DECREMENT, data: {payload, guard}})
        }
    }
    return (
        <div onClick={toggleIsCounterActiveClick} className={classList.join(" ")}>
            <ProgressBarWithPause
                isStart={isActive}
                isPause={isActive && isCounterActive}
                duration={currentStepDelay}
            />

            <CounterManager
                isVisible={isActive && isCounterActive}
                count={counterSettings.local.value}
                onIncrement={() => changeCount('inc')}
                onDecrement={() => changeCount('dec')}
                isActive={isCounterActive}
                onAction={toggleIsCounterActiveClick}
                style={{position: "absolute", top: "-50%"}}
            />
        </div>
    );
};

export {ProgressBarManager};